import Bugsnag from '@bugsnag/js';
import { useExpertServiceLazyQuery } from '../../../graph';

const DESIGN_LIVE_SERVICE_MPV_ID = 'designLive';
const CARE_DESIGN_SERVICE_MPV_ID = 'careDesign';
const OTHER_DESIGN_SERVICE_MPV_ID = 'otherDesign';

export type ResolveServiceProductMpvIdParams = {
    serviceProductMpvId?: string | null;
    printProductMpvId: string | undefined;
    locale: string;
};

export function useResolveServiceProductMpvId() {
    const [fetchExpertService] = useExpertServiceLazyQuery();

    return async function resolveServiceProductMpvId({
        serviceProductMpvId,
        printProductMpvId,
    }: ResolveServiceProductMpvIdParams): Promise<string> {
        if (serviceProductMpvId?.toLowerCase() === DESIGN_LIVE_SERVICE_MPV_ID.toLowerCase()) {
            return DESIGN_LIVE_SERVICE_MPV_ID;
        }

        if (!printProductMpvId) {
            return CARE_DESIGN_SERVICE_MPV_ID;
        }

        const { data, error } = await fetchExpertService({
            variables: { mpvId: printProductMpvId },
        });
        if (error) {
            Bugsnag.notify(
                new Error(
                    `Error fetching expert service for print product mpvId ${printProductMpvId}: ${error.message}`
                )
            );
        }

        const resolvedMpvId = data?.expertService?.serviceProduct?.mpvId;

        if (resolvedMpvId?.toLowerCase() === OTHER_DESIGN_SERVICE_MPV_ID.toLowerCase()) {
            return OTHER_DESIGN_SERVICE_MPV_ID;
        }

        const isOverflowEligible = data?.expertService?.isOverflowEligible ?? false;

        if (isOverflowEligible && resolvedMpvId) {
            return resolvedMpvId;
        }

        return CARE_DESIGN_SERVICE_MPV_ID;
    };
}
